import * as React from 'react';
import { routeConfig, RouteConfig } from '../../__config__/routeConfig';

interface ISiteContext {
  routeConfig: RouteConfig | null;
  contextData: any;
  setContextData: any;
}
export const SiteContext = React.createContext<ISiteContext>({
  routeConfig: null,
  contextData: null,
  setContextData: () => {},
});
export const SiteContextProvider: React.FC = ({ children }) => {
  const [contextData, setContextData] = React.useState({});

  return (
    <SiteContext.Provider
      value={{
        routeConfig,
        contextData,
        setContextData,
      }}
    >
      {children}
    </SiteContext.Provider>
  );
};
